module.exports = function() {
  return new Worker(__webpack_public_path__ + "fe8514802d3ca9b9d605.worker.js");
};